<app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
 
[value]="conditions?.garanties" 
 
[label]="step7.getgaranties"
[type]="'text'" [rule]="''"
[name]="getUid()+'_SepAtt_garanties'">
</app-form-input>
<app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg1" [id]="getStepId() + rg1"></app-form-input-error>

<app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
 
[value]="conditions?.modFinancement" 
 
[label]="step7.getmodfinancement"
[type]="'text'" [rule]="''"
[name]="getUid()+'_SepAtt_modFinancement'">
</app-form-input>
<app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg2" [id]="getStepId() + rg2"></app-form-input-error>

<app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
 
[value]="''"
 
[label]="step7.geteuro"
[type]="'checkbox'" [rule]="'pattern_29'"
[checkboxDestination]="'string'"
[isChecked]="conditions?.euro"
[name]="getUid()+'_SepAtt_euro'">
</app-form-input>

<app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
 
[value]="conditions?.formeJuridique" 
 
[label]="step7.getformejuridique"
[type]="'text'" [rule]="''"
[name]="getUid()+'_SepAtt_formeJuridique'">
</app-form-input>
<app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg3" [id]="getStepId() + rg3"></app-form-input-error>

<app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
 
[value]="''" 
 
[label]="step7.getlanguefr"
[type]="'checkbox'" [rule]="'pattern_29'"
[checkboxDestination]="'string'"
[isChecked]="conditions?.langueFR"
[name]="getUid()+'_SepAtt_langueFR'">
</app-form-input>

<app-type-langue  *ngIf="!langue()" [uid]="getUid()" [parentForm]="parentForm"
[disabled]="disabled"
 [langue]="conditions?.langue"></app-type-langue>

<app-form-input *ngIf="false"
[parentForm]="parentForm"
[disabled]="disabled"
 
[value]="conditions?.autresConditionsOui" 
 
[label]="step7.getspan7"
[type]="'radio'" [rule]="''"
[value]="radioButtonValue"
[name]="radioButtonCtrlName"
[radios]="[
						{
                            value: oui,
							label: step7.getautresconditionsoui
						},
                        {
                            value: non,
							label: step7.getautresconditionsnon
						}
    ]"
>
</app-form-input>

<!--<app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
 
[value]="conditions?.autresConditionsNon" 
 
[label]="step7.getautresconditionsnon"
[type]="'text'" [rule]="''"
[name]="getUid()+'_SepAtt_autresConditionsNon'">
</app-form-input>-->










